var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurnBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 206,
    viewBox: "0 0 580 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_129_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.215 87.8225C163.874 87.3967 163.461 87.4804 163.245 87.5673C163.063 87.6406 162.647 87.8749 162.705 88.4621C162.774 89.1671 162.813 89.886 162.82 90.5989C162.851 93.5564 161.661 96.4539 159.555 98.5484C157.463 100.629 154.71 101.751 151.78 101.718C147.777 101.667 144.457 99.586 142.179 95.6994C140.295 92.4857 141.123 88.3407 142 83.9522C142.513 81.3835 143.043 78.7271 143.043 76.199C143.043 56.5143 129.768 45.1576 121.854 40.14C121.691 40.0364 121.535 40 121.397 40C121.173 40 120.995 40.0965 120.907 40.1555C120.737 40.2702 120.466 40.5316 120.553 40.9942C123.578 57.0055 114.556 66.6354 105.004 76.8305C95.159 87.3394 84 99.2505 84 120.732C84 145.693 104.371 166 129.411 166C150.028 166 168.206 151.671 173.615 131.156C177.304 117.167 173.438 99.348 164.215 87.8225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.215 87.8225C163.874 87.3967 163.461 87.4804 163.245 87.5673C163.063 87.6406 162.647 87.8749 162.705 88.4621C162.774 89.1671 162.813 89.886 162.82 90.5989C162.851 93.5564 161.661 96.4539 159.555 98.5484C157.463 100.629 154.71 101.751 151.78 101.718C147.777 101.667 144.457 99.586 142.179 95.6994C140.295 92.4857 141.123 88.3407 142 83.9522C142.513 81.3835 143.043 78.7271 143.043 76.199C143.043 56.5143 129.768 45.1576 121.854 40.14C121.691 40.0364 121.535 40 121.397 40C121.173 40 120.995 40.0965 120.907 40.1555C120.737 40.2702 120.466 40.5316 120.553 40.9942C123.578 57.0055 114.556 66.6354 105.004 76.8305C95.159 87.3394 84 99.2505 84 120.732C84 145.693 104.371 166 129.411 166C150.028 166 168.206 151.671 173.615 131.156C177.304 117.167 173.438 99.348 164.215 87.8225Z",
    fill: "url(#paint0_radial_129_116)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_129_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9646 137.181C44.8691 139.007 47.3625 139.95 49.9843 139.83C55.0252 139.603 59.114 135.299 59.0988 130.234C59.0951 128.976 58.8521 127.754 58.3766 126.602C58.3236 126.474 58.2226 126.428 58.1471 126.412C58.0901 126.4 57.9415 126.384 57.8084 126.509C56.6616 127.586 55.1645 128.179 53.5927 128.179C50.3869 128.179 47.917 125.906 47.4462 122.522C47.2621 121.198 47.259 119.472 47.4372 117.393C47.4555 117.178 47.3193 117.079 47.2364 117.039C47.197 117.02 47.1399 117 47.0739 117C47.0011 117 46.9176 117.025 46.8361 117.102C41.8528 121.838 40 125.405 40 130.264C40 132.853 41.0806 135.374 42.9646 137.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9646 137.181C44.8691 139.007 47.3625 139.95 49.9843 139.83C55.0252 139.603 59.114 135.299 59.0988 130.234C59.0951 128.976 58.8521 127.754 58.3766 126.602C58.3236 126.474 58.2226 126.428 58.1471 126.412C58.0901 126.4 57.9415 126.384 57.8084 126.509C56.6616 127.586 55.1645 128.179 53.5927 128.179C50.3869 128.179 47.917 125.906 47.4462 122.522C47.2621 121.198 47.259 119.472 47.4372 117.393C47.4555 117.178 47.3193 117.079 47.2364 117.039C47.197 117.02 47.1399 117 47.0739 117C47.0011 117 46.9176 117.025 46.8361 117.102C41.8528 121.838 40 125.405 40 130.264C40 132.853 41.0806 135.374 42.9646 137.181Z",
    fill: "url(#paint1_radial_129_116)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_129_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.394 134.131C427.508 138.848 421.111 141.283 414.384 140.974C401.451 140.389 390.961 129.269 391 116.187C391.01 112.935 391.633 109.779 392.853 106.805C392.989 106.474 393.248 106.354 393.442 106.312C393.588 106.281 393.969 106.24 394.311 106.563C397.253 109.345 401.094 110.877 405.126 110.877C413.351 110.877 419.688 105.005 420.896 96.2649C421.368 92.8432 421.376 88.3855 420.919 83.0148C420.872 82.4607 421.222 82.2046 421.434 82.1011C421.535 82.0521 421.682 82 421.851 82C422.038 82 422.252 82.0634 422.461 82.2637C435.247 94.4966 440 103.711 440 116.263C440 122.952 437.228 129.464 432.394 134.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.394 134.131C427.508 138.848 421.111 141.283 414.384 140.974C401.451 140.389 390.961 129.269 391 116.187C391.01 112.935 391.633 109.779 392.853 106.805C392.989 106.474 393.248 106.354 393.442 106.312C393.588 106.281 393.969 106.24 394.311 106.563C397.253 109.345 401.094 110.877 405.126 110.877C413.351 110.877 419.688 105.005 420.896 96.2649C421.368 92.8432 421.376 88.3855 420.919 83.0148C420.872 82.4607 421.222 82.2046 421.434 82.1011C421.535 82.0521 421.682 82 421.851 82C422.038 82 422.252 82.0634 422.461 82.2637C435.247 94.4966 440 103.711 440 116.263C440 122.952 437.228 129.464 432.394 134.131Z",
    fill: "url(#paint2_radial_129_116)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.407 88.3178C465.894 87.7096 466.484 87.8291 466.793 87.9532C467.053 88.058 467.647 88.3927 467.564 89.2315C467.466 90.2387 467.41 91.2657 467.4 92.2841C467.356 96.5092 469.056 100.648 472.064 103.641C475.053 106.613 478.985 108.215 483.171 108.169C488.89 108.096 493.633 105.123 496.887 99.5706C499.579 94.9795 498.396 89.0582 497.143 82.7888C496.411 79.1192 495.653 75.3245 495.653 71.7129C495.653 43.5919 514.618 27.368 525.922 20.2C526.156 20.052 526.379 20 526.576 20C526.896 20 527.15 20.1378 527.275 20.2222C527.518 20.386 527.906 20.7594 527.782 21.4203C523.461 44.2936 536.349 58.0505 549.994 72.615C564.059 87.6277 580 104.644 580 135.332C580 170.99 550.898 200 515.127 200C485.674 200 459.706 179.531 451.978 150.222C446.708 130.239 452.231 104.783 465.407 88.3178Z",
    fill: "url(#paint3_radial_129_116)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_129_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.164 142.052C144.788 143.371 142.986 144.053 141.091 143.966C137.447 143.803 134.492 140.691 134.503 137.031C134.506 136.121 134.681 135.238 135.025 134.406C135.063 134.313 135.136 134.28 135.191 134.268C135.232 134.259 135.34 134.248 135.436 134.338C136.265 135.116 137.347 135.545 138.483 135.545C140.8 135.545 142.585 133.902 142.925 131.457C143.058 130.499 143.061 129.252 142.932 127.749C142.918 127.594 143.017 127.523 143.077 127.494C143.105 127.48 143.147 127.465 143.194 127.465C143.247 127.465 143.307 127.483 143.366 127.539C146.968 130.962 148.307 133.54 148.307 137.052C148.307 138.924 147.526 140.746 146.164 142.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.164 142.052C144.788 143.371 142.986 144.053 141.091 143.966C137.447 143.803 134.492 140.691 134.503 137.031C134.506 136.121 134.681 135.238 135.025 134.406C135.063 134.313 135.136 134.28 135.191 134.268C135.232 134.259 135.34 134.248 135.436 134.338C136.265 135.116 137.347 135.545 138.483 135.545C140.8 135.545 142.585 133.902 142.925 131.457C143.058 130.499 143.061 129.252 142.932 127.749C142.918 127.594 143.017 127.523 143.077 127.494C143.105 127.48 143.147 127.465 143.194 127.465C143.247 127.465 143.307 127.483 143.366 127.539C146.968 130.962 148.307 133.54 148.307 137.052C148.307 138.924 147.526 140.746 146.164 142.052Z",
    fill: "url(#paint4_radial_129_116)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_129_116",
    x: 44,
    y: 0,
    width: 171,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.0980392 0 0 0 0 0.901961 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_129_116",
    x: 0,
    y: 77,
    width: 99.0989,
    height: 102.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.0980392 0 0 0 0 0.901961 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_129_116",
    x: 351,
    y: 42,
    width: 129,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.0980392 0 0 0 0 0.901961 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_129_116",
    x: 94.5029,
    y: 87.4653,
    width: 93.8042,
    height: 96.5083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.0980392 0 0 0 0 0.901961 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_116"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_116",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_129_116",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.493 185.993) rotate(-43.9917) scale(141.09 216097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400034,
    stopColor: "#0096FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673266,
    stopColor: "#CE13EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_129_116",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.501 92.5004) rotate(113.787) scale(83.0558 127722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0325041,
    stopColor: "#00E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286873,
    stopColor: "#0096FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696149,
    stopColor: "#CE13EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_129_116",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(479.482 170.169) rotate(-159.128) scale(123.26 170891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400034,
    stopColor: "#0096FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673266,
    stopColor: "#CE13EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_129_116",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(515.003 311.997) rotate(-130.863) scale(207.579 317935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E8FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400034,
    stopColor: "#0096FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673266,
    stopColor: "#CE13EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_129_116",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.054 109.758) rotate(66.2132) scale(60.0304 92313.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0325041,
    stopColor: "#00E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286873,
    stopColor: "#0096FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696149,
    stopColor: "#CE13EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurnBg);
export default __webpack_public_path__ + "static/media/burn_bg.69ba1674eb6c3df8f00538e4918391a4.svg";
export { ForwardRef as ReactComponent };